import { AutoscalerSettingsState } from '../../features-op/cluster/settings-op/easy-mode/types';

export enum TourPages {
  Dashboard = 'dashboard',
  AutoscalerSettings = 'autoscaler-settings',
  WoopList = 'woop-list',
  NodeList = 'node-list',
  Rebalancer = 'rebalancer',
  RebalancingProgress = 'rebalancing-progress',
  RebalancingCompleted = 'rebalancing-completed',
}

export enum TourSteps {
  Initial = '0-initial',
  EnableWoop = '10-enable-woop', // Workload optimization
  GoToWoop = '20-go-to-woop', // Observe optimization
  UnoptimizedWorkloads = '30-unoptimized-workloads', // Workload optimization process
  GoToAutoscalerSettings = '40-go-to-autoscaler-settings', // Impact on the CPU requests
  EnableEvictor = '50-enable-evictor', // Enable evictor
  GoToNodesAfterEnablingEvictor = '60-go-to-nodes', // Observe nodes
  ObserveEvictorOnNodes = '70-observe-evictor-on-nodes', // Nodes getting empty
  EnableNodeAutoscaler = '80-enable-node-autoscaler', // Nodes optimization
  GoToNodesAfterEnablingNodeAutoscaler = '90-go-to-nodes-after-enabling-node-autoscaler', // See Node Autoscaling in Action
  GoToRebalancer = '100-go-to-rebalancer', // Optimize for Cost
  RebalanceNow = '110-rebalance-now', // New configuration review
  RebalanceProgress = '120-rebalance-progress', // Rebalancing in progress (collection-based)
  RebalancingFinished = '130-rebalancing-finished', // Rebalancing in progress (collection-based)
  ShowDemoResults = '140-demo-results', // Finish rebalancing
}

// All the data is returned from middleware, no need to declare it `tour-steps.tsx`
// The only thing mocked in App layer is autoscaler settings flags
export type TourPageToState = {
  [TourPages.Dashboard]: never;
  [TourPages.AutoscalerSettings]: AutoscalerSettingsState;
  [TourPages.WoopList]: never;
  [TourPages.NodeList]: never;
  [TourPages.Rebalancer]: never;
  [TourPages.RebalancingProgress]: never;
  [TourPages.RebalancingCompleted]: never;
};
